import React, { useState , useEffect} from "react";
import Navbar from "../../components/Navbar/Index";
import { useOutletContext, Link } from "react-router-dom";
import GroupTable from "./GroupsTable";
import axios from "axios";
import { useDispatch } from 'react-redux';
import {updateGroups} from '../../actions/GroupActions';
import { useSelector } from 'react-redux';
function Table() {
  const [sidebarToggle] = useOutletContext();
  const [loading] = useState(false);
  // const [groups, setGroups] = useState([]);
  const [reload, setReload] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const groups = useSelector(state => state.Groups);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/groups/all', {
          headers: {
            Authorization: `Bearer ${user?.idToken }`
          }
        });
        // setGroups(response.data);
        dispatch(updateGroups(response.data));

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [reload]); // Empty dependency array to run effect only once on component mount
  const dataHeader = [
    {
      key: "groupname",
      label: "G-Name",
    },
    {
      key: "owner",
      label: "Owner",
    },
    {
      key: "amount",
      label: "Total Expense",
    },
    {
      key: "expense",
      label: "You Owe",
    },
    {
      key: "action",
      label: "Action",
    },
  ];

  const data = [];
  if (groups.length>=1){
    groups.map((item,i)=>{
      data.push({
        id:i,
        groupid:item.gid,
        name:item.groupName,
        owner:item.created_by,
        amount:item.totalExpense,
        expense:item.debt,
        gid:item.gid
      })
    })
  }
  
  return (
    <>
      <main className="h-full">
        <Navbar toggle={sidebarToggle} />

        {/* Main Content */}
        <div className="mainCard">
          <div className="border w-full border-gray-200 bg-white py-4 px-6 rounded-md">
            <GroupTable
              loading={loading}
              dataHeader={dataHeader}
              data={data}
              setReload={setReload}
              reload={reload}
            />
          </div>
        </div>
        <div className="fixed bottom-20 right-8">
              <div className="relative">
            <Link to="/groupform">
            <button className="plus-button rounded-full bg-green-500 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"  style={{width: "40px", height: "40px"}}>
              +
            </button>
            </Link>
          
           
          </div>
        </div>
      </main>
    </>
  );
}

export default Table;
